import { render, staticRenderFns } from "./TaxReport.vue?vue&type=template&id=6a8323a9&"
import script from "./TaxReport.vue?vue&type=script&lang=js&"
export * from "./TaxReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports